import { defineComponent as d, computed as l, openBlock as i, createElementBlock as c, createElementVNode as t, toDisplayString as f, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const v = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "3ae1b258-1234-4afe-86d9-ff65cddb2760" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#3ae1b258-1234-4afe-86d9-ff65cddb2760)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#338af3" d="M0 0h512v141l-64 115 64 115v141H0V371l64-115L0 141Z"></path><path fill="#eee" d="M0 141h512v23l-256 16L0 164Z"></path><path fill="#333" d="M0 164h512v38l-256 16L0 202Z"></path><path fill="#6da544" d="m0 220 256 16 256-16v-18H0Z"></path><path fill="#eee" d="M0 371h512v-23l-256-16L0 348Z"></path><path fill="#ff9811" d="M0 348h512v-38l-256-16L0 310Z"></path><path fill="#6da544" d="m0 292 256-16 256 16v18H0Z"></path><path fill="#ffda44" d="M0 220h512v72H0z"></path><circle cx="256" cy="248" r="64" fill="#eee"></circle><path fill="#eee" d="m178 301 78-29 78 29v27H178Z"></path>', 10), g = { fill: "none" }, x = ["r"], M = /* @__PURE__ */ d({
  __name: "east_african_federation",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, a = l(() => 512 + 2 * e.strokeWidth), o = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (Z, w) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${a.value} ${a.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (i(), c("title", k, f(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, v));
  }
});
export {
  M as default
};
//# sourceMappingURL=east_african_federation-42040837.js.map
